import styled from 'styled-components';

const FooterPartners = styled.div`
  display: flex;
  height: 106px;
  align-items: center;
  align-content: center;
  gap: 10px 15px;
  flex-shrink: 0;
  align-self: stretch;
  flex-wrap: wrap;
  position: relative;
  opacity: 0.5;

  @media (max-width: 768px) {
    gap: 10px 0;
    margin: 18px 0;
  }
`;
export { FooterPartners };
